<template>
  <el-dialog
    :visible="visible"
    title="Options"
    @close="$emit('close')"
  >
    <div class="d-flex">
      <el-button
        :loading="isDownloadingOrderCsv"
        @click="handleGenerateCsvByOrder"
      >
        By Order
      </el-button>
      <el-button
        :loading="isDownloadingProductCsv"
        @click="handleGenerateCsvByProduct"
      >
        By Product
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { createComponent, ref } from '@vue/composition-api'

const GenerateCsvDialog = createComponent({
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },
  setup(props, { emit }) {
    const isDownloadingOrderCsv = ref(false)
    const handleGenerateCsvByOrder = () => {
      isDownloadingOrderCsv.value = true
      const onSuccess = () => {
        isDownloadingOrderCsv.value = false
      }
      emit('generate-csv', {
        type: 'order',
        onSuccess,
      })
    }

    const isDownloadingProductCsv = ref(false)
    const handleGenerateCsvByProduct = () => {
      isDownloadingProductCsv.value = true
      const onSuccess = () => {
        isDownloadingProductCsv.value = false
      }
      emit('generate-csv', {
        type: 'product',
        onSuccess,
      })
    }

    return {
      isDownloadingOrderCsv,
      handleGenerateCsvByOrder,

      isDownloadingProductCsv,
      handleGenerateCsvByProduct,
    }
  },
})

export default GenerateCsvDialog
</script>
